import { List } from 'react-admin'
import ResourceListHeader from '../components/ResourceListHeader'
import DeviceDatagrid from './DeviceDatagrid'

const DeviceList = () => (
  <>
    <ResourceListHeader resource="devices" />
    <List sort={{ field: 'start_time', order: 'DESC' }}>
      <DeviceDatagrid rowClick="" />
    </List>
  </>
)

export default DeviceList
